import React, { useState, useEffect } from 'react';
import { wellnessFormFields } from './wellnessForm';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AyuraAIlogo from "../Assests/images/Logo 4.png";
import Loader from './loader'
import { useNavigate, useSearchParams } from "react-router-dom";


const DynamicForm = () => {
  const initialFormState = {};
  const navigate = useNavigate();
  wellnessFormFields.forEach((field) => {
    initialFormState[field.id] = field.type === 'checkbox' ? [] : '';
  });
  const [searchParams] = useSearchParams();
  const uid = searchParams.get('uid');
  const [user, setUser] = useState();

  const [formData, setFormData] = useState(initialFormState);
  const [userNew, setUserNew] = useState();

  const [formDataNew, setFormDataNew] = useState(initialFormState);
  const [otherInputs, setOtherInputs] = useState({}); 
  const [heightUnit, setHeightUnit] = useState("ft-in");
  const [loading, setLoading] = useState(false);



  const handleChange = (e, field) => {
    const { name, value, type, checked } = e.target;

    if (field.type === 'checkbox') {
      const updated = checked
        ? [...formData[name], value]
        : formData[name].filter((item) => item !== value);
      setFormData({ ...formData, [name]: updated });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleOtherInputChange = (e, fieldId) => {
    setOtherInputs({ ...otherInputs, [fieldId]: e.target.value });
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    for (const field of wellnessFormFields) {
      const value = formData[field.id];
      if (field.type === "checkbox" && Array.isArray(value) && value.length === 0) {
        toast.error(`Please select at least one option for "${field.label}"`);
        return;
      }

      if (field.id === "height") {
        if (heightUnit === "ft-in") {
          if (!formData.height?.heightFt || !formData.height?.heightIn) {
            toast.error(`Please fill both feet and inches for "Height"`);
            return;
          }
        } else {
          if (!formData.height) {
            toast.error(`Please fill "Height" in cm`);
            return;
          }
        }
        continue;
      }

      if (
        (field.type !== "checkbox" && field.id !== "height") &&
        (value === undefined || value === null || value === "")
      ) {
        toast.error(`Please fill the field "${field.label}"`);
        return;
      }
    }

    let processedFormData = { ...formData };
    if (formData.height && formData.height.heightFt && formData.height.heightIn) {
      processedFormData.height = `${formData.height.heightFt}' ${formData.height.heightIn}`;
    }

    Object.keys(processedFormData).forEach((key) => {
      if (Array.isArray(processedFormData[key]) && processedFormData[key].includes("Other")) {
        const otherValue = otherInputs[key];
        processedFormData[key] = [
          ...processedFormData[key].filter((item) => item !== "Other"),
          ...(otherValue ? [otherValue] : []),
        ];
      }
    });

    const labeledData = {};
    wellnessFormFields.forEach((field) => {
      const label = field.label;
      const answer = processedFormData[field.id];

      if (Array.isArray(answer)) {
        labeledData[label] = answer.join(", ");
      } else {
        labeledData[label] = answer;
      }
    });
    

    toast.info("Submitting...");
    console.log("Sending labeled data", labeledData);
    setLoading(true);
    try {
      await axios.post(
        "https://2mwtcttdj4.execute-api.ap-south-1.amazonaws.com/dev/submitMicroBiome",
        // "http://localhost:5000/submitMicroBiome",
        labeledData
      );
      navigate("/success");
      toast.success("Form submitted successfully!");
    } catch (error) {
      toast.error("Error submitting the form.");
      setLoading(false);
    }
  };


  useEffect(() => {
    if (!uid) return;

    const fetchUser = async () => {
      try {
        setLoading(true);
        const res = await axios.get(`https://2mwtcttdj4.execute-api.ap-south-1.amazonaws.com/dev/users/${uid}`);
        const userData = res.data;
        setUser(userData);

        const address = userData?.address || {};

        let height = "";
        let unit = "ft-in";

        if (address.heightFt && address.heightIn) {
          height = {
            heightFt: address.heightFt || "",
            heightIn: address.heightIn || "",
          };
          unit = "ft-in";
        } else if (address.height) {
          height = address.height;
          unit = "cm";
        }

        setHeightUnit(unit);

        const updatedForm = {
          aaiCode: address.aaiCode || "",
          firstName: address.firstName || "",
          lastName: address.lastName || "",
          age: address.age || "",
          gender: address.gender || "",
          height: height,
          weight: address.weight || "",
          pregnant: address.isPregnant || "",
          residence: address.city || "",
        };

        setFormData((prev) => ({
          ...prev,
          ...updatedForm,
        }));
      } catch (err) {
        console.error("Error loading user:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, [uid]);

  return (
    <div>
      {loading && <Loader />}
          <div className="ayurveda-health-form">
      <div className="navbar-logo mb-4">
        <img src={AyuraAIlogo} alt="Logo" />
      </div>
      <form onSubmit={handleSubmit} className="complete-form">
        <h1 className="form-title">Ayurvedic Wellness Form</h1>
        <h5 className="form-subtitle">Fill in your details below</h5>

        {wellnessFormFields.map((field) => (
          <div key={field.id} className="mb-4">
            <label className="form-question">{field.label}</label>

            {field.id === "height" ? (
              <>
                <select
                  value={heightUnit}
                  onChange={(e) => setHeightUnit(e.target.value)}
                  className="mb-2 p-2 border border-gray-300 rounded-md"
                >
                  <option value="ft-in">ft/inches</option>
                  <option value="cm">cm</option>
                </select>

                {heightUnit === "ft-in" ? (
                  <div className="flex gap-2">
                    <input
                      type="number"
                      placeholder="ft"
                      name="heightFt"
                      value={formData.height?.heightFt || ""}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          height: { ...prev.height, heightFt: e.target.value },
                        }))
                      }
                      className="p-2 border border-gray-300 rounded-md w-1/2"
                    />
                    <input
                      type="number"
                      placeholder="inches"
                      name="heightIn"
                      value={formData.height?.heightIn || ""}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          height: { ...prev.height, heightIn: e.target.value },
                        }))
                      }
                      className="p-2 border border-gray-300 rounded-md w-1/2"
                    />
                  </div>
                ) : (
                  <input
                    type="number"
                    name="height"
                    placeholder="cm"
                    value={typeof formData.height === "string" ? formData.height : ""}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        height: e.target.value,
                      }))
                    }
                    className="w-full p-2 border border-gray-300 rounded-md"
                  />
                )}
              </>
            ) : null}

            {(field.type === "text" || field.type === "number") &&
              field.id !== "height" && (
                <input
                  type={field.type}
                  name={field.id}
                  value={formData[field.id]}
                  onChange={(e) => handleChange(e, field)}
                  className="w-full p-2 border border-gray-300 rounded-md"
                />
              )}

            {field.type === "textarea" && (
              <textarea
                name={field.id}
                rows={3}
                value={formData[field.id]}
                onChange={(e) => handleChange(e, field)}
                className="form-textarea"
              />
            )}

            {field.type === "radio" &&
              field.options.map((opt) => (
                <label key={opt} className="form-answer block mb-1">
                  <input
                    type="radio"
                    name={field.id}
                    value={opt}
                    checked={formData[field.id] === opt}
                    onChange={(e) => handleChange(e, field)}
                    className="form-radio"
                  />
                  <span className="pl-2">{opt}</span>
                </label>
              ))}

            {field.type === "checkbox" && (
              <div className="wellness-container">
                {field.options.map((opt) => (
                  <div key={opt} className="form-answer-new">
                    <label className="flex items-center">
                      <input
                        type="checkbox"
                        name={field.id}
                        value={opt}
                        checked={formData[field.id].includes(opt)}
                        onChange={(e) => handleChange(e, field)}
                        className="form-checkbox"
                      />
                      <span className="ml-2">{opt}</span>
                    </label>

                    {opt === "Other" &&
                      formData[field.id].includes("Other") && (
                        <input
                          type="text"
                          placeholder="Please specify"
                          className="ml-2 mt-2 p-2 border border-gray-300 rounded-md w-full"
                          value={otherInputs[field.id] || ""}
                          onChange={(e) =>
                            handleOtherInputChange(e, field.id)
                          }
                        />
                      )}
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}

        <button type="submit" className="submit-button">
          Submit
        </button>
      </form>
      <ToastContainer position="top-center" autoClose={3000} />
    </div>
    </div>


  );
};

export default DynamicForm;
